module.exports = __webpack_public_path__ + "static/media/G-7ths.205a0371.png";